import PropTypes from 'prop-types';

export const TimeOfDay = {
  MORNING: 'MORNING',
  AFTERNOON: 'AFTERNOON',
  EVENING: 'EVENING',
};

export const TimeOfDayShape = PropTypes.oneOf(Object.values(TimeOfDay));

export const ManagementPagePanel = {
  ORDERS_PANEL: '0',
  SETTINGS_PANEL: '1',
  SUGGESTED_ORDER_PANEL: '2',
};

export const OrderType = {
  ACTUAL: 'ACTUAL',
  PROBLEM: 'PROBLEM',
  VIRTUAL: 'VIRTUAL',
};

export const OrderTypeShape = PropTypes.oneOf(Object.values(OrderType));

export const EditOrderStatus = {
  EDITABLE: 'EDITABLE',
  BEING_EDITED: 'BEING_EDITED',
  NOT_EDITABLE: 'NOT_EDITABLE',
};
export const EditOrderStatusShape = PropTypes.oneOf(Object.values(EditOrderStatus));

export const SettingsTab = {
  HOLIDAYS: 'HOLIDAYS',
  PAYMENT: 'PAYMENT',
  MEMBERSHIP: 'MEMBERSHIP',
};

export const SettingsTabShape = PropTypes.oneOf(Object.values(SettingsTab));

export const SuggestedOrderFrequency = {
  ALWAYS: 'ALWAYS',
  SOMETIMES: 'SOMETIMES',
  NEVER: 'NEVER',
  ALL: 'ALL',
};

export const SuggestedOrderFrequencyShape = PropTypes.oneOf(Object.values(SuggestedOrderFrequency));

export const OrderBuildStatus = {
  ITEMS_UNAVAILABLE: 'ITEMS_UNAVAILABLE',
  SLOT_UNAVAILABLE: 'SLOT_UNAVAILABLE',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  SLOT_ALREADY_BOOKED: 'SLOT_ALREADY_BOOKED',
  UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
};

export const OrderBuildStatusShape = PropTypes.oneOf(Object.values(OrderBuildStatus));
